import * as Yup from 'yup'
import {
    communicationMethods,
    contactTimePreferences,
    paroIncomeStatus,
    projectTypes,
    totalFreelanceExperience,
    weeklyWorkloadHours
} from "../../../shared/constants/workPreferences"
import {getItemTypeValues} from "../_local/service"

const totalFreelanceExperienceOptions = getItemTypeValues(totalFreelanceExperience)
const weeklyWorkloadHoursOptions  = getItemTypeValues(weeklyWorkloadHours)
const projectTypeOptions = getItemTypeValues(projectTypes)
const paroIncomeStatusOptions = getItemTypeValues(paroIncomeStatus)
const contactTimePreferenceOptions = getItemTypeValues(contactTimePreferences)
const contactStylePreferenceOptions = getItemTypeValues(communicationMethods)

const workPrefsValidationSchema = Yup.object().shape({
    contactStylePreference: Yup.string().oneOf(contactStylePreferenceOptions).required(),
    contactTimePreference:  Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.string().oneOf(contactTimePreferenceOptions).required()
    }),
    paroIncomeStatus: Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.string().oneOf(paroIncomeStatusOptions).required()
    }),
    hasCurrentClients: Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.boolean().oneOf([true, false], 'Field must be checked').required()
    }),
    isOpenToOnsite: Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.boolean().oneOf([true, false], 'Field must be checked').required() }),
    intendedMonthlyIncome: Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.number().required('You must enter a monthly income goal') }),
    projectType:  Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.string().oneOf(projectTypeOptions).required()
    }),
    weeklyWorkloadHours:  Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.string().oneOf(weeklyWorkloadHoursOptions).required()
    }),
    totalFreelanceExperience: Yup.mixed().when('isSaveAndExit', {
        is: undefined,
        then: Yup.string().oneOf(totalFreelanceExperienceOptions).required()
    }),
})

export default workPrefsValidationSchema
